import { z } from 'zod';

export const LevelDefSchema = z.object({
  id: z.string().min(1),
  terms: z.number().int().min(1).max(6),
  icon: z.enum(['x', 'pm', 'sigma']),
});
export type LevelDef = z.infer<typeof LevelDefSchema>;

/** Task shapes, shared by every mode. Adding one is a config entry, not code. */
export const levels: readonly LevelDef[] = z.array(LevelDefSchema).parse([
  { id: 'l1', terms: 1, icon: 'x' },
  { id: 'l2', terms: 2, icon: 'pm' },
  { id: 'l3', terms: 3, icon: 'sigma' },
]);

export type LevelId = (typeof levels)[number]['id'];
